/**
 * Os meses que a faixa de semanas atravessa, para o eixo embaixo da grade. Função PURA.
 *
 * A faixa cobre a carteira inteira (dezenas de quadrinhos de 24px) e cada um deles diz
 * apenas "22/10" no tooltip: sem o eixo, ninguém sabe se o aglomerado de vermelho está em
 * novembro ou em janeiro, que é a primeira coisa que se pergunta ao olhar a carteira.
 */

/** Um mês da faixa: quantas semanas consecutivas dele estão na tela. */
export interface IBlocoDeMes {
  /** 'YYYY-MM': chave estável, porque o eixo pode atravessar a virada do ano. */
  chave: string;
  /** 1 a 12, para a tela buscar o nome traduzido do mês. */
  mes: number;
  /** Quantos quadrinhos este mês ocupa, em sequência. */
  semanas: number;
}

/**
 * Os blocos na ordem das semanas. O mês de uma semana é o da SEGUNDA-FEIRA dela: uma
 * semana que começa em 30/11 e termina em 06/12 conta como novembro, que é onde o
 * quadrinho está desenhado.
 *
 * Data ilegível é simplesmente ignorada, em vez de abrir um bloco sem nome: a grade
 * continua desenhada e o eixo apenas não fala daquela semana.
 */
export function blocosDeMes(semanas: ReadonlyArray<{ inicio: string }>): Array<IBlocoDeMes> {
  const blocos: Array<IBlocoDeMes> = [];
  for (const semana of semanas) {
    const [ano, mes] = (semana.inicio ?? '').split('-');
    const numero = Number(mes);
    if (ano === undefined || !Number.isInteger(numero) || numero < 1 || numero > 12) {
      continue;
    }
    const chave = `${ano}-${mes}`;
    const ultimo = blocos[blocos.length - 1];
    if (ultimo !== undefined && ultimo.chave === chave) {
      ultimo.semanas += 1;
      continue;
    }
    blocos.push({ chave, mes: numero, semanas: 1 });
  }
  return blocos;
}
